import { render, staticRenderFns } from "./FacturasCuadreVentaEstacion.vue?vue&type=template&id=0bb77f70&scoped=true&"
import script from "./FacturasCuadreVentaEstacion.vue?vue&type=script&lang=js&"
export * from "./FacturasCuadreVentaEstacion.vue?vue&type=script&lang=js&"
import style0 from "./FacturasCuadreVentaEstacion.vue?vue&type=style&index=0&id=0bb77f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb77f70",
  null
  
)

export default component.exports